import { PricingPlan } from '@/types';

export const PROFESSIONAL_PLAN_PRICE_COP = 29900;
export const EXTRA_PROFESSIONAL_PRICE_COP = 19900;
export const INCLUDED_PROFESSIONALS = 1;

export const pricingPlans: PricingPlan[] = [
  {
    name: 'Profesional',
    price: '29,900',
    extraProfessionalPrice: '19,900',
    currency: 'COP',
    period: '/mes',
    description: 'Para profesionales y pequeños negocios que necesitan más capacidad y quieren automatizar parte de sus reservas con el bot opcional de WhatsApp.',
    professionals: '1 profesional',
    features: [
      'Todo lo incluido en el Plan Gratis',
      'Bot de WhatsApp opcional para gestionar reservas',
      'Envío de recordatorios por WhatsApp desde la agenda',
      'Hasta 10 categorías de actividad',
      'Servicios ilimitados',
      'Horarios y ausencias, con opción de sumar profesionales',
    ],
    highlighted: true,
    ctaText: 'Elegir Plan Profesional',
  },
];

export const mainPricingPlan = pricingPlans[0];
